// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3OQ01","content":"styles_content__3ajHj"};